import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@/environments/environment';
import { getHeaders } from '../tramite.service';
import { ApiService } from '@/app/shared/service/api.service';

@Component({
  selector: 'app-consulta-catalogo',
  templateUrl: './consulta-catalogo.component.html',
  styleUrls: ['./consulta-catalogo.component.scss']
})
export class ConsultaCatalogoComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;

  // Datos
  tramites: any[] = [];
  filteredTramites: any[] = [];
  tramiteDetalles: any = null;
  
  // Tabla
  displayedColumns: string[] = ['nombre', 'codigo', 'tipo', 'categoria', 'area', 'tiempo', 'modalidad', 'verDetalle'];
  dataSource = new MatTableDataSource<any>();
  
  // Búsqueda y Filtros
  searchValue: string = '';
  selectedArea: string = '';
  selectedDependencia: string = '';
  selectedSolicitante: string = '';
  selectedTipo: string = '';
  selectedCategoria: string = '';
  
  // Listas para filtros
  dependencias: any[] = [];
  areas: any[] = [];
  tiposSolicitante: string[] = ['Personas físicas', 'Personas morales'];
  
  // Estados
  isLoading: boolean = false;
  isLoadingDetails: boolean = false;
  viewMode: 'grid' | 'list' = 'grid';
  showSearchMenu: boolean = false;
  
  // Modal
  modalRef: NgbModalRef | null = null;
  
  // Estadísticas
  totalTramites: number = 0;
  tramitesEnLinea: number = 0;
  tramitesPresenciales: number = 0;
  
  // Paginación
  limit: number = 10;
  offset: number = 0;
  currentPage: number = 1;
  totalRecords: number = 0;
  totalPages: number = 0;
  
  private baseUrl = environment.API_URL;

  constructor(
    private http: HttpClient,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.loadTramites();
    this.loadDependencias();
    this.loadAreas();
  }

  /**
   * Cargar trámites con paginación
   */
  loadTramites(): void {
    this.isLoading = true;
    const headers = getHeaders();
    
    // Calcular offset basado en la página actual
    this.offset = (this.currentPage - 1) * this.limit;
    
    this.http.get<any>(`${this.baseUrl}/miveracruz/forms?limit=${this.limit}&offset=${this.offset}`, { headers })
      .subscribe(
        (response: any) => {
          // Manejar tanto respuesta paginada como array directo
          let data: any[] = [];
          let total: number = 0;
          
          if (response && response.list && Array.isArray(response.list)) {
            // Respuesta paginada: {list, total, page, pageSize, Count}
            data = response.list;
            total = response.total || response.Count || response.list.length;
          } else if (Array.isArray(response)) {
            // Respuesta directa como array (sin paginación del servidor)
            data = response;
            total = response.length;
          } else {
            console.warn('Formato de respuesta inesperado:', response);
            data = [];
            total = 0;
          }
          
          this.tramites = data;
          this.filteredTramites = data;
          this.totalRecords = total;
          this.totalPages = Math.ceil(this.totalRecords / this.limit);
          
          this.dataSource = new MatTableDataSource(this.filteredTramites);
          
          if (this.sort) {
            this.dataSource.sort = this.sort;
          }
          
          this.calculateStatistics();
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          console.error('Error al cargar los trámites:', error);
          this.sendNotification('Error', 'No se pudieron cargar los trámites del catálogo', 'error');
          this.isLoading = false;
          this.tramites = [];
          this.filteredTramites = [];
          this.dataSource = new MatTableDataSource([]);
          this.totalRecords = 0;
          this.totalPages = 0;
        }
      );
  }

  /**
   * Cargar dependencias para filtro
   */
  loadDependencias(): void {
    this.apiService.getCatalogInfo('Departments', 1000, 0).subscribe(
      (data: any) => {
        try {
          let dependenciasArray: any[] = [];
          
          // Manejar diferentes formatos de respuesta
          if (data && data.list && Array.isArray(data.list)) {
            dependenciasArray = data.list.map((dept: any) => ({
              id: dept.id,
              Name: dept.ValueAlpha || dept.Name || dept.name
            }));
          } else if (Array.isArray(data)) {
            dependenciasArray = data.map((dept: any) => ({
              id: dept.id,
              Name: dept.ValueAlpha || dept.Name || dept.name
            }));
          }
          
          // Filtrar elementos inválidos
          this.dependencias = Array.isArray(dependenciasArray) 
            ? dependenciasArray.filter(d => d && d.Name) 
            : [];
          console.log('Dependencias cargadas:', this.dependencias);
        } catch (error) {
          console.error('Error procesando dependencias:', error);
          this.dependencias = [];
        }
      },
      (error) => {
        console.error('Error al cargar dependencias:', error);
        this.dependencias = [];
      }
    );
  }

  /**
   * Cargar áreas para filtro
   */
  loadAreas(): void {
    this.apiService.getCatalogInfo('Areas', 1000, 0).subscribe(
      (data: any) => {
        try {
          let areasArray: any[] = [];
          
          // Manejar diferentes formatos de respuesta
          if (data && data.list && Array.isArray(data.list)) {
            areasArray = data.list.map((area: any) => ({
              id: area.id,
              Name: area.ValueAlpha || area.Name || area.name
            }));
          } else if (Array.isArray(data)) {
            areasArray = data.map((area: any) => ({
              id: area.id,
              Name: area.ValueAlpha || area.Name || area.name
            }));
          }
          
          // Filtrar elementos inválidos
          this.areas = Array.isArray(areasArray) 
            ? areasArray.filter(a => a && a.Name) 
            : [];
          console.log('Áreas cargadas:', this.areas);
        } catch (error) {
          console.error('Error procesando áreas:', error);
          this.areas = [];
        }
      },
      (error) => {
        console.error('Error al cargar áreas:', error);
        this.areas = [];
      }
    );
  }

  /**
   * Calcular estadísticas
   */
  calculateStatistics(): void {
    // Las estadísticas se basan en el total de registros, no solo los de la página actual
    // Por ahora usamos los datos disponibles, pero idealmente deberían venir del servidor
    this.totalTramites = this.totalRecords;
    this.tramitesEnLinea = this.tramites.filter(t => t.Form?.FormsCommon?.IsOnline === true).length;
    this.tramitesPresenciales = this.totalTramites - this.tramitesEnLinea;
  }

  /**
   * Aplicar filtros
   * Nota: Con paginación del servidor, los filtros deberían aplicarse en el servidor
   * Por ahora, aplicamos filtros localmente a los datos de la página actual
   */
  applyFilters(): void {
    // Si hay filtros activos, recargar desde el servidor (idealmente con parámetros de filtro)
    // Por ahora, aplicamos filtros localmente a los datos de la página actual
    let filtered = [...this.tramites];

    // Filtro por búsqueda
    if (this.searchValue) {
      filtered = filtered.filter(item => 
        this.searchInTramite(item, this.searchValue)
      );
    }

    // Filtro por tipo
    if (this.selectedTipo) {
      filtered = filtered.filter(item => 
        item.Form?.FormsCommon?.Type === this.selectedTipo
      );
    }

    // Filtro por categoría
    if (this.selectedCategoria) {
      filtered = filtered.filter(item => 
        item.Category?.Name === this.selectedCategoria
      );
    }

    // Filtro por dependencia
    if (this.selectedDependencia) {
      filtered = filtered.filter(item => {
        const dependenciaNombre = item.Area?.Departments?.Name || item.Form?.Areas?.Departments?.Name;
        return dependenciaNombre === this.selectedDependencia;
      });
    }

    // Filtro por área
    if (this.selectedArea) {
      filtered = filtered.filter(item => {
        const areaNombre = item.Area?.Name || item.Form?.Areas?.Name;
        return areaNombre === this.selectedArea;
      });
    }

    // Filtro por solicitante
    if (this.selectedSolicitante) {
      filtered = filtered.filter(item => {
        const applicant = item.Form?.FormsCommon?.Applicant || '';
        if (typeof applicant === 'string') {
          return applicant.includes(this.selectedSolicitante);
        }
        return false;
      });
    }

    this.filteredTramites = filtered;
    this.dataSource = new MatTableDataSource(this.filteredTramites);
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  /**
   * Búsqueda mejorada en múltiples campos
   */
  searchInTramite(item: any, searchValue: string): boolean {
    const search = searchValue.toLowerCase();
    return (
      item.Form?.FormsCommon?.Name?.toLowerCase().includes(search) ||
      item.Form?.FormsCommon?.Code?.toLowerCase().includes(search) ||
      item.Form?.FormsCommon?.Type?.toLowerCase().includes(search) ||
      item.Category?.Name?.toLowerCase().includes(search) ||
      item.Area?.Name?.toLowerCase().includes(search) ||
      item.Area?.Departments?.Name?.toLowerCase().includes(search) ||
      item.Form?.Areas?.Departments?.Name?.toLowerCase().includes(search) ||
      item.Form?.FormsCommon?.Applicant?.toLowerCase().includes(search) ||
      item.Form?.FormsDetail?.Description?.toLowerCase().includes(search)
    );
  }

  /**
   * Limpiar todos los filtros
   */
  clearFilters(): void {
    this.searchValue = '';
    this.selectedArea = '';
    this.selectedDependencia = '';
    this.selectedSolicitante = '';
    this.selectedTipo = '';
    this.selectedCategoria = '';
    this.currentPage = 1;
    this.loadTramites();
  }

  /**
   * Cambiar a página anterior
   */
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadTramites();
    }
  }

  /**
   * Cambiar a página siguiente
   */
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadTramites();
    }
  }

  /**
   * Ir a página específica
   */
  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.loadTramites();
    }
  }

  /**
   * Cargar página específica (usado por ngb-pagination)
   */
  loadPage(page: number): void {
    this.currentPage = page;
    this.loadTramites();
  }

  /**
   * Cambiar límite de registros por página
   */
  changeLimit(newLimit: number): void {
    this.limit = newLimit;
    this.currentPage = 1;
    this.loadTramites();
  }

  /**
   * Toggle del menú de filtros
   */
  toggleSearchMenu(): void {
    this.showSearchMenu = !this.showSearchMenu;
    const cardElement = document.querySelector('.card') as HTMLElement;
    if (cardElement) {
      if (this.showSearchMenu) {
        cardElement.classList.add('show-menu');
      } else {
        cardElement.classList.remove('show-menu');
      }
    }
  }

  /**
   * Obtener rango de registros mostrados
   */
  getRecordsRange(): string {
    const start = this.offset + 1;
    const end = Math.min(this.offset + this.limit, this.totalRecords);
    return `${start}-${end} de ${this.totalRecords}`;
  }

  /**
   * Obtener números de página para mostrar en la paginación
   */
  getPageNumbers(): (number | string)[] {
    const pages: (number | string)[] = [];
    const maxPages = 5; // Máximo de números de página a mostrar
    
    if (this.totalPages <= maxPages) {
      // Si hay pocas páginas, mostrar todas
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Si hay muchas páginas, mostrar primera, última y alrededor de la actual
      if (this.currentPage <= 3) {
        // Estamos cerca del inicio
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - 2) {
        // Estamos cerca del final
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages - 3; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Estamos en el medio
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      }
    }
    
    return pages;
  }

  /**
   * Obtener valores únicos para filtros
   */
  getUniqueValues(key: string): string[] {
    const values = this.tramites.map(t => {
      if (key === 'tipo') return t.Form?.FormsCommon?.Type;
      if (key === 'categoria') return t.Category?.Name;
      if (key === 'area') return t.Area?.Name;
      return null;
    }).filter((v, i, arr) => v && arr.indexOf(v) === i);

    return values.sort();
  }

  /**
   * Abrir detalles del trámite
   */
  verDetalles(tramite: any, content: any): void {
    this.isLoadingDetails = true;
    this.tramiteDetalles = null;

    // Cargar información completa del trámite
    this.http.get<any>(`${this.baseUrl}/miveracruz/forms/${tramite.Form.id}`, { headers: getHeaders() })
      .subscribe(
        (data) => {
          this.tramiteDetalles = data;
          this.openModal(content);
          this.isLoadingDetails = false;
        },
        (error) => {
          console.error('Error al cargar detalles:', error);
          this.sendNotification('Error', 'No se pudieron cargar los detalles del trámite', 'error');
          this.isLoadingDetails = false;
        }
      );
  }

  /**
   * Abrir modal
   */
  openModal(content: any): void {
    const modalConfig = {
      size: 'lg',
      centered: true,
      backdrop: true,
      keyboard: true
    };
    
    this.modalRef = this.modalService.open(content, modalConfig);
  }

  /**
   * Cerrar modal
   */
  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  /**
   * Ver trámite completo
   */
  verTramiteCompleto(id: number): void {
    this.closeModal();
    this.router.navigate(['/catalogs/ver-tramite', id]);
  }

  /**
   * Solicitar trámite
   */
  solicitarTramite(id: number): void {
    this.closeModal();
    this.router.navigate(['/catalogs/create-request', id]);
  }

  /**
   * Ordenar datos
   */
  sortData(sort: Sort): void {
    if (!sort.active || sort.direction === '') {
      return;
    }

    const data = this.filteredTramites.slice();
    this.filteredTramites = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      
      switch (sort.active) {
        case 'nombre':
          return this.compare(a.Form?.FormsCommon?.Name, b.Form?.FormsCommon?.Name, isAsc);
        case 'codigo':
          return this.compare(a.Form?.FormsCommon?.Code, b.Form?.FormsCommon?.Code, isAsc);
        case 'tipo':
          return this.compare(a.Form?.FormsCommon?.Type, b.Form?.FormsCommon?.Type, isAsc);
        case 'categoria':
          return this.compare(a.Category?.Name, b.Category?.Name, isAsc);
        case 'area':
          return this.compare(a.Area?.Name, b.Area?.Name, isAsc);
        case 'tiempoRespuesta':
          return this.compare(
            a.Form?.FormsCommon?.AnswerTime, 
            b.Form?.FormsCommon?.AnswerTime, 
            isAsc
          );
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.filteredTramites);
  }

  /**
   * Comparar valores para ordenamiento
   */
  compare(a: any, b: any, isAsc: boolean): number {
    if (a === null && b === null) return 0;
    if (a === null) return 1;
    if (b === null) return -1;
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Formatear fecha
   */
  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX');
  }

  /**
   * Formatear tiempo
   */
  formatTime(time: number, type: string): string {
    if (!time) return '-';
    return `${time} ${type}`;
  }

  /**
   * Verificar si hay filtros activos
   */
  hasActiveFilters(): boolean {
    return !!(
      this.searchValue ||
      this.selectedArea ||
      this.selectedDependencia ||
      this.selectedSolicitante
    );
  }

  /**
   * Enviar notificación
   */
  sendNotification(title: string = 'Catálogo de Trámites', message: string, type: string): void {
    this.toastr[type](message, title, { timeOut: 3500 });
  }

  /**
   * Obtener modalidad del trámite
   */
  getModalidad(isOnline: boolean): string {
    return isOnline ? 'En línea' : 'Presencial';
  }

  /**
   * Obtener color de modalidad
   */
  getModalidadColor(isOnline: boolean): string {
    return isOnline ? 'success' : 'warning';
  }

  /**
   * Exportar catálogo
   */
  exportToPDF(): void {
    // Implementar exportación a PDF
    this.sendNotification('Info', 'Funcionalidad de exportación en desarrollo', 'info');
  }

  /**
   * Exportar catálogo a Excel
   */
  exportToExcel(): void {
    // Implementar exportación a Excel
    this.sendNotification('Info', 'Funcionalidad de exportación en desarrollo', 'info');
  }

  /**
   * Navegar a página de creación de nuevo trámite
   */
  agregarNuevoTramite(): void {
    this.router.navigate(['/catalogs/create-tramite']);
  }
}

